import React, { useEffect, useState } from "react";
import { ArrowPathIcon } from "@heroicons/react/24/solid";
import { useDispatch, useSelector } from "react-redux";
import { fetchAreas } from "../../../../redux/reducer/areaReducer";
import ApiBase from "../../../../redux/constent";

const EditBrandForm = ({
  editForm,
  onChange,
  onFileChange,
  onSubmit,
  onCancel,
  isLoading,
}) => {
  const dispatch = useDispatch();
  const { areas } = useSelector((state) => state.areas);

  const [selectedAreaId, setSelectedAreaId] = useState(editForm.area || "");
  const [selectedSuperCategoryId, setSelectedSuperCategoryId] = useState(
    editForm.category || ""
  );
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState(
    editForm.subCategory || ""
  );

  const [superCategories, setSuperCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  useEffect(() => {
    dispatch(fetchAreas());
  }, [dispatch]);

  useEffect(() => {
    const selectedArea = areas?.find((area) => area._id === selectedAreaId);
    setSuperCategories(selectedArea?.category || []);
  }, [selectedAreaId, areas]);

  useEffect(() => {
    const fetchSubCategories = async () => {
      const selectedSuperCategory = superCategories.find(
        (cat) => cat._id === selectedSuperCategoryId
      );
      if (!selectedSuperCategory || !selectedSuperCategory.subCategory) {
        setSubCategories([]);
        return;
      }

      try {
        const results = await Promise.all(
          selectedSuperCategory.subCategory.map(async (id) => {
            const response = await fetch(`${ApiBase}/subCategory/${id}`);
            const data = await response.json();
            return data;
          })
        );
        setSubCategories(results);
      } catch (error) {
        console.error("Error fetching subcategories:", error);
        setSubCategories([]);
      }
    };

    if (selectedSuperCategoryId) {
      fetchSubCategories();
    }
  }, [selectedSuperCategoryId, superCategories]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(
      {
        ...editForm,
        area: selectedAreaId,
        category: selectedSuperCategoryId,
        subCategory: selectedSubCategoryId,
      },
      e
    );
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="grid grid-cols-2 gap-2 p-6 bg-white rounded-lg shadow-lg w-[90%] max-w-2xl"
    >
      {/* Area Dropdown */}
      <div className="col-span-2">
        <label className="text-sm font-semibold text-black">Area</label>
        <select
          className="w-full px-3 py-2 text-sm text-black bg-gray-100 border rounded-md"
          value={selectedAreaId}
          onChange={(e) => setSelectedAreaId(e.target.value)}
        >
          <option value="" className="text-black">
            Choose Area
          </option>
          {areas?.map((area) => (
            <option key={area._id} value={area._id} className="text-black">
              {area.name?.en}
            </option>
          ))}
        </select>
      </div>

      {/* Category Dropdown */}
      <div className="col-span-2">
        <label className="text-sm font-semibold text-black">Category</label>
        <select
          className="w-full px-3 py-2 text-sm text-black bg-gray-100 border rounded-md"
          value={selectedSuperCategoryId}
          onChange={(e) => setSelectedSuperCategoryId(e.target.value)}
        >
          <option value="" className="text-black">
            Choose Category
          </option>
          {superCategories?.map((cat) => (
            <option key={cat._id} value={cat._id} className="text-black">
              {cat.title?.en}
            </option>
          ))}
        </select>
      </div>

      {/* SubCategory Dropdown */}
      <div className="col-span-2">
        <label className="text-sm font-semibold text-black">Subcategory</label>
        <select
          className="w-full px-3 py-2 text-sm text-black bg-gray-100 border rounded-md"
          value={selectedSubCategoryId}
          onChange={(e) => setSelectedSubCategoryId(e.target.value)}
        >
          <option value="" className="text-black">
            Choose Subcategory
          </option>
          {subCategories?.map((sub) => (
            <option
              key={sub.data?._id}
              value={sub.data?._id}
              className="text-black"
            >
              {sub.data?.name?.en}
            </option>
          ))}
        </select>
      </div>
      <hr className="col-span-2 my-2" />
      {/* Other Inputs */}
      <div className="flex flex-col">
        <label className="text-sm font-semibold text-black">Title (EN)</label>
        <input
          type="text"
          name="nameEn"
          value={editForm.nameEn}
          onChange={onChange}
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div>
      <div className="flex flex-col">
        <label className="text-sm font-semibold text-black">Title (AR)</label>
        <input
          type="text"
          name="nameAr"
          value={editForm.nameAr}
          onChange={onChange}
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div>
      <div className="flex flex-col">
        <label className="text-sm font-semibold text-black">Link</label>
        <input
          type="text"
          name="link"
          value={editForm.link}
          onChange={onChange}
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div>
      <div className="flex flex-col">
        <label className="text-sm font-semibold text-black">Image</label>
        <input
          type="file"
          name="image"
          accept="image/*"
          onChange={onFileChange}
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div>
      <div className="flex flex-col col-span-2">
        <label className="text-sm font-semibold text-black">Description</label>
        <textarea
          name="desc"
          value={editForm.desc}
          onChange={onChange}
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div>

      {/* Buttons */}
      <div className="flex justify-end col-span-2 mt-2 space-x-3">
        {!isLoading && (
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 text-white duration-300 bg-gray-600 rounded-lg hover:bg-gray-800"
          >
            Cancel
          </button>
        )}
        {isLoading ? (
          <ArrowPathIcon className="w-10 h-10 p-2 text-white rounded-full animate-spin bg-custom-yellow" />
        ) : (
          <button
            type="submit"
            className="px-4 py-2 text-white duration-300 rounded-lg bg-custom-yellow hover:bg-yellow-600"
          >
            Submit
          </button>
        )}
      </div>
    </form>
  );
};

export default EditBrandForm;
